import React from "react";
import {demoInterestsList, goToResults} from "../api/lessons";
import { useHistory } from "react-router-dom";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import FormLabel from "@material-ui/core/FormLabel";
import Typography from "@material-ui/core/Typography";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";

type Choice = {
  value: string,
  label: string,
  subchoices: Choice[]
}

export default function ChooseInterests() {
  const history = useHistory();
  const [state, setState] = React.useState(demoInterestsList.slice(0, 3))

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      setState(state.concat([event.target.name]));
    } else {
      setState(state.filter((prop, key) => prop !== event.target.name));
    }
  };

  const onClick = () => {
    goToResults(state, history)
  };

  return (
    <div>
      <FormControl component="fieldset">
        <FormGroup>
          {demoInterestsList.map((prop, key) => {
            return (
              <FormControlLabel
                control={<Checkbox checked={state.includes(prop)} onChange={handleChange} name={prop} />}
                label={prop}
              />
            )
          })}
        </FormGroup>
        <div>
          <Button color="secondary" onClick={onClick}>Поиск</Button>
        </div>
      </FormControl>
    </div>
  )
}
